<script setup lang="ts">
definePageMeta({
  auth: false,
});

useHead({
  title: 'Privacy Policy',
});

const { data } = await useFetchData('/pages/privacy', { method: 'GET' });
</script>

<template>
  <v-container class="pa-0 mt-5 mb-10">
    <div class="pt-6">
      <div v-html="data"></div>
    </div>
  </v-container>
</template>
